var map = {
	"./bg-chip.png": 71247,
	"./chip-select.png": 41176,
	"./chip1.png": 44284,
	"./chip2.png": 33015,
	"./chip3.png": 59374,
	"./chip4.png": 42465,
	"./chip5.png": 53400,
	"./chip6.png": 44243,
	"./chip7.png": 93482,
	"./chip8.png": 70077,
	"./chip9.png": 48948,
	"./chipBAR.png": 26142,
	"./left-arrow.svg": 84652,
	"./right-arrow.svg": 20051
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39871;